import { HEADER_HEIGHT, TOP_BAR_HEIGHT } from '@v2/components/header/constants';

/**
 * Any landing component can carry `settings.anchor_id`, which becomes the `id` of its
 * section wrapper so a link like `/fa/v2/landing/myopia-control-v1#risk-test` lands on it.
 */

// The value reaches us from an admin free-text field and is written straight into the DOM
// as an id and matched against `location.hash`, so keep it to the characters that survive
// both. Anything else is treated as unset rather than silently mangled.
const VALID_ANCHOR = /^[A-Za-z][A-Za-z0-9_-]*$/;

export function readAnchorId(settings: unknown): string | undefined {
    const value = (settings as { anchor_id?: unknown } | undefined)?.anchor_id;
    if (typeof value !== 'string') return undefined;

    const trimmed = value.trim();
    return VALID_ANCHOR.test(trimmed) ? trimmed : undefined;
}

// The header is fixed, so an element scrolled to the top of the viewport sits underneath
// it. Same offset the PLP header holder reserves.
export const ANCHOR_SCROLL_MARGIN = {
    xs: HEADER_HEIGHT.mobile + TOP_BAR_HEIGHT,
    md: HEADER_HEIGHT.tablet + TOP_BAR_HEIGHT,
    md2: HEADER_HEIGHT.desktop + TOP_BAR_HEIGHT,
};

// The browser applies `#hash` while the page is still settling, and never applies it
// at all when the page was fetched on the client, so the scroll is re-run from the
// shared helper every page with sections uses.
export { scrollToHashTarget, scrollToHashTargetWhenSettled } from '@v2/helpers/hashScroll';
